import { els } from './variables';
import { isDesktopMenu, isMobileMenu } from './main-menu';

const stickyRevealHeader = {
	/**
	 * Tracks the current scroll position on the page.
	 */
	lastScrollTop: 0,

	/**
	 * Initialize the component.
	 */
	init() {
		this.siteNotice = els.header.querySelector('.site-notice') ?? 0;
		this.offsetElement = document.querySelector('.site-content > *:first-child');
		this.anchorNav = document.querySelector('.ppc-header__anchors');

		this.checkScrollPosition = this.checkScrollPosition.bind(this);
		this.updateContentOffset = this.updateContentOffset.bind(this);
		this.updateNavHeight = this.updateNavHeight.bind(this);

		const update = () => {
			this.checkScrollPosition();
			this.updateContentOffset();
			this.updateNavHeight();
		};

		window.addEventListener('load', update);
		window.addEventListener('resize', update);
		window.addEventListener('scroll', this.checkScrollPosition);
	},

	/**
	 * Check the current scroll position and determine if the header should have a class added or removed.
	 */
	checkScrollPosition() {
		window.requestAnimationFrame(() => {
			if (!els.html.classList.contains('no-scroll')) {
				if (isDesktopMenu() || this.siteNotice) {
					// Get the current scroll position.
					const scrollTop = window.pageYOffset;

					let maxTranslateY = 1;
					if (this.siteNotice) {
						const noticeStyles = window.getComputedStyle(this.siteNotice);
						maxTranslateY += this.siteNotice.clientHeight + parseInt(noticeStyles.getPropertyValue('margin-bottom'));
					} else {
						const headerStyles = window.getComputedStyle(els.header);
						maxTranslateY += parseInt(headerStyles.getPropertyValue('padding-top'));
					}

					if (maxTranslateY > 1) {
						const translateY = scrollTop <= maxTranslateY ? scrollTop : maxTranslateY;
						els.header.style.transform = `translateY(${-translateY}px)`;

						if (translateY === maxTranslateY) {
							els.header.classList.add('anchored');
						} else {
							els.header.classList.remove('anchored');
						}
					}

					// Update the value for lastScrollTop for subsequenet comparisons within this function.
					this.lastScrollTop = scrollTop;
				} else {
					els.header.classList.remove('anchored');
					els.header.style.transform = '';
				}
			}
		});
	},

	updateContentOffset() {
		window.requestAnimationFrame(() => {
			if (this.offsetElement && !this.anchorNav) {
				this.offsetElement.style.paddingTop = `${els.header.clientHeight}px`;
			} else {
				const height = els.header.clientHeight + 20;
				this.anchorNav.style.paddingTop = `${height}px`;
			}
		});
	},

	updateNavHeight() {
		window.requestAnimationFrame(() => {
			if (els.navContainer) {
				els.navContainer.style.height = isMobileMenu() ? `${window.innerHeight - els.headerInner.clientHeight}px` : '';
			}
		});
	},
};

document.addEventListener('DOMContentLoaded', () => {
	stickyRevealHeader.init();
});
